/**
 * Pickup instructions hierarchy (SoT)
 *
 * Resolution order:
 *   1. product.pickup_instructions  (if trimmed length > 0)
 *   2. producer.pickup_instructions (if trimmed length > 0)
 *   3. fallback constant
 */

export const PICKUP_FALLBACK_TEXT = 'Utlämning sker enligt överenskommelse.';

export type PickupSource = 'product' | 'producer' | 'fallback';

export interface ResolvedPickup {
  text: string;
  source: PickupSource;
}

export function resolvePickupInstructions(opts: {
  productInstructions?: string | null;
  producerInstructions?: string | null;
}): ResolvedPickup {
  const product = opts.productInstructions?.trim();
  if (product && product.length > 0) {
    return { text: product, source: 'product' };
  }

  const producer = opts.producerInstructions?.trim();
  if (producer && producer.length > 0) {
    return { text: producer, source: 'producer' };
  }

  return { text: PICKUP_FALLBACK_TEXT, source: 'fallback' };
}
